import React from "react";
import Navbar from "../navbar/Navbar";
import Footer from "../footer/Footer";
import SupportPrime from "./support_prime/SupportPrime";
import CallerIdSetup from "./caller_id_setup/CallerIdSetup";
import SeoComponent from "../../../SeoComponent";
import ChatIcon from "../chat/ChatIcon";
import ScrollToTop from "../scroll-icon/ScrollToTop";
import GoToTop from "../scroll-icon/GoToTop";

const Support = () => {
  return (
    <div>
      <SeoComponent pageUrl="/support" businessTitle="FusionPOS" />
      <GoToTop />
      <Navbar />
      <SupportPrime />
      <CallerIdSetup />
      <Footer />
      <ScrollToTop />
      <ChatIcon />
    </div>
  );
};

export default Support;
